import { render, staticRenderFns } from "./TagsForm.vue?vue&type=template&id=4e1aade3&scoped=true"
import script from "./TagsForm.vue?vue&type=script&lang=js"
export * from "./TagsForm.vue?vue&type=script&lang=js"
import style0 from "./TagsForm.vue?vue&type=style&index=0&id=4e1aade3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1aade3",
  null
  
)

export default component.exports